export default "__VITE_ASSET__0d94a24f__"